import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import isEmpty from "lodash/isEmpty";
import { getItems } from "src/client/js/store/selectors/cart";
import { filterBundles } from "./helpers";
import Bundle from "./Bundle/Bundle";

const getBundles = (items, excludeProducts) =>
  items.map((item, idx) => (
    <Bundle key={idx} bundle={item} excludeProducts={excludeProducts} />
  ));

const ProductBundle = (props) => {
  const cartProducts = useSelector((state) => getItems(state));
  const products = cartProducts.map((p) => ({
    id: p.format.product.id,
    customisations: p.customisations,
  }));
  const filteredBundles = filterBundles(props.items, products);

  if (isEmpty(filteredBundles)) {
    return null;
  }

  return (
    <section className="container-guttered ProductBundle">
      {getBundles(filteredBundles, products)}
    </section>
  );
};

ProductBundle.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      bundleCtasText: PropTypes.string,
      description: PropTypes.string,
      title: PropTypes.string,
      products: PropTypes.array,
    })
  ),
};

export default ProductBundle;
